module.exports = __webpack_public_path__ + "static/media/afffilate.c5239654.svg";